const BASE = '$appbase'

export const MODAL_CURRENT = `${BASE}/modal`
export const PAGE_CURRENT = `${BASE}/page/info`
export const TEAMS = `${BASE}/teams`

export const MODAL_CHANGE = `${BASE}/modal/change`
export const SELECT_ATTACHMENT = `${BASE}/select/attachment`;
